import axios from 'axios'

export const state = {
  staffs: {},
}

export const getters = {
  listStaffs(state) {
    return state.staffs
  },
}

export const mutations = {
  SET_STAFFS(state, staffs) {
    state.staffs = staffs
  },
  TOGGLE_SHOW_DETAIL(state, id) {
    state.staffs.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.staffs.data.splice(index, 1)
        state.staffs.data.splice(index, 0, item)
      }
    });
  },
}

export const actions = {
  getStaffs({commit}, params = {}) {
    return axios.get(`/staffs/search`, {params}).then(({data}) => {
      return commit('SET_STAFFS', data)
    })
  },
  getListStaffs({ commit }, params = {}) {
    return axios.get('/staffs/search', { params })
  },
  exportStaffsCsv({commit}, params = {}) {
    return axios.get('/staffs/export', {params});
  },
  createStaff({commit}, data) {
    return axios.post('/staffs', data)
  },
  updateStaff({commit}, staff) {
    const data = {
      first_name: staff.first_name,
      last_name: staff.last_name,
      status: staff.status,
      avatar: staff.avatar,
      emails: staff.emails,
      phones: staff.phones,
      roles: staff.roles,
      addresses: staff.addresses,
      notes: staff.notes,
    }

    return axios.put(`/staffs/${staff.id}`, data)
  },
  getStaff({commit}, id) {
    return axios.get(`/staffs/${id}`);
  },
  toggleStaffDataDetails: function ({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
  importStaff({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/staffs/import', formData, {responseType: responseType})
  },
  downloadImportStaffTemplate({ commit }, params = {}) {
    return axios.get(`/import/staff/download-template`, {responseType: 'blob'})
  },
}
